import { addFilter, type FilterCallback } from "@/extensions/hooks";

const NAMESPACE = "duke/plugins/preselect-dependent-from-dropdown";

const findSharedAttributeCode = (commonAttributes: any[]): string | undefined =>
  commonAttributes.find((attribute) =>
    attribute.labelOptions?.options?.some((option: any) => option.label === "None"),
  )?.attributeCode;

const hasValue = (value: unknown) => value !== undefined && value !== null && value !== "";

export const preselectDependentFromDropdown: FilterCallback<"dependentProducts.preselect"> = (
  value,
  { groups, groupId, attributeSetId, optionSet, commonAttributes },
) => {
  const parents = Array.from(optionSet.get(groupId)?.parents.values() ?? []);
  const rowParent = parents.find((parent) => parent.parentAttributeSetKey === attributeSetId);
  if (!rowParent) return value;

  const sharedAttributeCode = findSharedAttributeCode(commonAttributes);
  const dependentParents = parents.filter((parent) =>
    rowParent.dependentParent?.includes(parent.parentAttributeSetKey),
  );

  // attributeCode -> option value picked in the dropdown
  const selections = new Map<string, string>();
  const addSelection = (attributeCode: string, selected: unknown) => {
    if (hasValue(selected)) selections.set(attributeCode, String(selected));
  };

  for (const child of rowParent.child) {
    if (child.attributeCode === sharedAttributeCode) {
      addSelection(child.attributeCode, child.selectedOption?.value);
    }
  }
  for (const parent of dependentParents) {
    for (const child of parent.child) addSelection(child.attributeCode, child.selectedOption?.value);
  }
  if (!selections.size) return value;

  // Compares only the attributes the dependent product carries; all of them must match
  const match = groups.find((group) => {
    const compared = Array.from(selections).filter(([code]) => hasValue(group.bundleProduct?.[code]));
    return (
      compared.length > 0 &&
      compared.every(([code, selected]) => String(group.bundleProduct[code]) === selected)
    );
  });
  return match ?? value;
};

export const registerPreselectDependentFromDropdown = () =>
  addFilter("dependentProducts.preselect", NAMESPACE, preselectDependentFromDropdown);
